module.exports = __webpack_public_path__ + "img/product-ketang-jbg-01.d2614c92.png";